import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { UserIdleService } from 'angular-user-idle';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from './services/authentication.service';
import { VersionCheckService } from './services/version-check.service';
import { InactivityModalComponent } from './ui-widgets/modals/inactivity-modal/inactivity-modal.component';
declare const gtag: Function;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'eyelation';

  modalRef: NgbModalRef | any;

  onTimerstartSubscription: Subscription | undefined;
  onTimeoutSubscription: Subscription | undefined;
  subscriptions: Subscription[] = [];

  constructor(
    private _authService: AuthenticationService,
    private _userIdleService: UserIdleService,
    private _modalService: NgbModal,
    private _router: Router,
    private _versionCheckerService: VersionCheckService
  ) {
    // Google Analytics
    this._router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        gtag('event', 'page_view', {
          'page_path': event.urlAfterRedirects,
          'page_location': document.location.href
        });
      }
    });
  }

  ngOnInit(): void {
    // Check every 4 hours.
    this._versionCheckerService.initVersionCheck(environment.checkVersionUrl);

    this._authService.isAuthenticated.subscribe(a => {
      if (!a.valueOf()) {
        this.unsubscribeAll();
        return;
      }

      this.checkUserInactivity();
    });
  }

  private checkUserInactivity() {
    // Start watching for user inactivity.
    this._userIdleService.startWatching();

    this.onTimerstartSubscription = this._userIdleService.onTimerStart()
      .subscribe((count) => {
        this.onTimerStartHandler(count);
      });

    this.onTimeoutSubscription = this._userIdleService.onTimeout()
      .subscribe(() => {
        this.onTimeoutHandler();
      });

    // Add subscriptions to list, in order to unsubscribe them when isAuth = false.
    this.addSubscriptions();
  }

  private onTimerStartHandler(count: number) {
    // Start watching when user idle is starting.
    if (count === 1) {
      this.modalRef = this._modalService.open(InactivityModalComponent, {
        backdrop: 'static',
        keyboard: false
      });
    } else {
      this.modalRef.componentInstance.counter = count;
    }
  }

  private onTimeoutHandler() {
    // Stop watch when time is up.
    this._userIdleService.stopWatching();
    this.modalRef.close();
    this.modalRef = null;
    this._authService.logout();
  }

  private addSubscriptions() {
    if (this.onTimerstartSubscription)
      this.subscriptions.push(this.onTimerstartSubscription);

    if (this.onTimeoutSubscription)
      this.subscriptions.push(this.onTimeoutSubscription);
  }

  private unsubscribeAll() {
    if (this.subscriptions.length > 0) {
      this.subscriptions.forEach(sub => sub.unsubscribe());
      this.subscriptions = [];
    }
  }
}
